import AfSwitch from '@/components/AfSwitch';
import PersonImage from '@/components/PersonImage';
import { ApplicationState } from '@/store';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

interface Props {
    name: string;
    automaticEnroll: boolean;
    enrolled: boolean;
    handleChange: CallableFunction;
    enrolledInAnotherClass: boolean;
    thumbnail: string | undefined;
}

const StudentCard = ({ name, automaticEnroll, enrolled, handleChange, enrolledInAnotherClass, thumbnail }: Props) => {
    const { strings, loading } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        loading: state.programClass.loading,
    }));
    const [internalChecked, setInternalChecked] = useState<boolean>(false);
    const [switchDisabled, setSwitchDisabled] = useState<boolean>(false);

    const isEnrolledOrEnrolledInAnotherClass = enrolledInAnotherClass
        ? strings.ENROLLED_IN_ANOTHER_CLASS
        : internalChecked
        ? strings.ENROLLED
        : strings.NOT_ENROLLED;

    useEffect(() => {
        if (!loading) {
            setSwitchDisabled(false);
        }
    }, [loading]);

    useEffect(() => {
        setInternalChecked(enrolled);
    }, [enrolled]);

    return (
        <div className="student-card">
            <aside>
                <div className={`avatar ${enrolledInAnotherClass ? 'enrolled-in-another-class' : ''}`}>
                    <PersonImage size={30} src={thumbnail} />
                </div>
                <label className={enrolledInAnotherClass ? 'enrolled-in-another-class' : ''}>{name}</label>

                {automaticEnroll && (
                    <i className="target material-icons align-middle" tabIndex={1}>
                        adjust
                    </i>
                )}
            </aside>
            <aside className={enrolledInAnotherClass ? 'enrolled-in-another-class-label' : ''}>
                <label className={'title'}>{isEnrolledOrEnrolledInAnotherClass}</label>
                {!enrolledInAnotherClass && (
                    <AfSwitch
                        checked={internalChecked}
                        disabled={switchDisabled}
                        onChange={(checked: boolean) => {
                            if (!switchDisabled) {
                                setSwitchDisabled(true);
                                handleChange(checked);
                                setInternalChecked(checked);
                            }
                        }}
                    />
                )}
            </aside>
        </div>
    );
};

export default StudentCard;
